import axios from '../api'
const getUsableOrdersByGroupId = params => {
  console.log(params)
  return axios({
    url: `/eos/coupon/sendCoupon/getUsableOrdersByGroupId`,
    params
  })
}
const sendCoupon = params => {
  return axios({
    url: `/eos/coupon/sendCoupon/sendCoupon`,
    method: 'post',
    data: params,
    timeout:300000
  })
}

const ifHaveCheckingOrders = params => {
  console.log(params)
  return axios({
    url: `/eos/coupon/sendCoupon/ifHaveCheckingOrders`,
    params
  })
}
export default {
  getUsableOrdersByGroupId,
  sendCoupon,
  ifHaveCheckingOrders
}
